module.exports = __webpack_public_path__ + "static/media/bala-natarajan.6121e98d.jpg";